<template>
  <a
    :href="href"
    :target="target ?? '_self'"
    class="transition hover:-translate-y-0.5 active:translate-y-0"
  >
    <div
      class="flex w-full items-center justify-center gap-1 rounded-[var(--microsite-button-border-radius)] bg-[var(--microsite-button-background-color)] px-4 text-center font-medium text-[var(--microsite-button-text-color)] [box-shadow:var(--microsite-button-box-shadow)]"
      style="overflow-wrap: anywhere"
      :class="small ? 'min-h-8 py-1' : 'min-h-12 py-3'"
    >
      <Component
        :is="icon"
        v-if="icon"
        class="shrink-0"
        :class="small ? 'size-4' : 'size-5'"
      />
      <slot />
    </div>
  </a>
</template>

<script setup lang="ts">
import type { Component } from 'vue';

defineProps<{
  href: string;
  target?: string;
  icon?: Component | null;
  small?: boolean;
}>();

defineSlots<{
  default(): unknown;
}>();
</script>
